import {isArray} from '@utils'

export function filterSlotVNodes( scope, slotName, targetComponentName ) {
    // find proper slot vnodes
    let slotVNodes = scope.$slots[slotName]
    if( !!!slotVNodes && !!scope.$scopedSlots[slotName] ) {
        slotVNodes = scope.$scopedSlots[slotName]
    }

    let result = []

    for(let index in slotVNodes) {
        let child = slotVNodes[index]

        // check current child if matches target component name
        if( child.componentOptions && child.componentOptions.tag === targetComponentName ) {
            result.push( child )
        }
    }

    return result
}

export function findFirstParent( vm, targetComponentName ) {
    if( vm.$parent === undefined ) {
        return false
    }

    if( vm.$parent.$vnode && vm.$parent.$vnode.componentOptions.tag === targetComponentName ) {
        return vm.$parent
    }

    return findFirstParent(vm.$parent, targetComponentName)
}

/**
 * Use it by wrapping this function in nextTick:
 *
 *  Vue.nextTick(function () {
 *      findFirstChild(this, 'target-child-component')
 *  })
 *
 */
export function findFirstChild( vm, targetComponentName ) {
    for(let index in vm.$children) {
        let child = vm.$children[index]

        // check current child
        if( child.$vnode.componentOptions.tag === targetComponentName ) {
            return child
        }

        // search in child children
        let chidrenSearchResult = findFirstChild(child, targetComponentName)

        if( chidrenSearchResult !== false ) {
            return chidrenSearchResult
        }
    }

    return false
}

export function findFirstChildDOM( el, filterCallback ) {
    for(let index in el.children) {
        let child = el.children[index]

        if( child.tagName !== undefined ) {
            let childTag = child.tagName.toLowerCase()

            if( true === filterCallback(childTag, child) ) {
                return child
            }
        }

        // search in child children
        let chidrenSearchResult = findFirstChildDOM(child, filterCallback)

        if( chidrenSearchResult !== false ) {
            return chidrenSearchResult
        }
    }

    return false
}

export function mergeEvents(pool1, pool2) {
    for (let event in pool2) {
        if (pool2.hasOwnProperty(event)) {
            pool1 = addEvent(pool1, event, pool2[event])
        }
    }

    return pool1
}

export function addEvent(pool, event, func) {
    if( ! pool[event] )
        pool[event] = []

    if( isArray(pool[event]) ) {
        pool[event].push(func)
    } else {
        pool[event] = [
            pool[event],
            func
        ]
    }

    return pool
}

/**
 * Convert user defined filters into common format
 *
 * @return {Array} Formatted filters
 */
export function normalizeFilters(raw) {
    // Convert:
    // 'capitalize'
    // OR
    // {
    //     date_format: ['Y-m-d'],
    //     other_filter: 'abc'
    // }
    // OR
    // (val) => {
    //     return val + ' ...'
    // }
    // OR
    // [
    //     'capitalize',
    //     {
    //         date_format: ['Y-m-d'],
    //         other_filter: 'abc'
    //     },
    //     (val) => {
    //         return val + ' ...'
    //     }
    // ]
    // Into:
    // [
    //     { filter: 'capitalize', params: [] },
    //     { filter: 'date_format', params: ['Y-m-d'] },
    //     { filter: 'other_filter', params: ['abc'] },
    //     { filter: (val) => { return val + ' ...'}, params: [] }
    // ]

    let normalize = function(raw) {
        let filters = []

        if ( isObject(raw) ) {
            for(let filter in raw) {
                let params = []

                if( isArray(raw[filter]) ) {
                    params = raw[filter]
                } else {
                    params.push(raw[filter])
                }

                filters.push({
                    filter,
                    params
                })
            }
        } else { // on String or Function
            filters.push({
                filter: raw,
                params: []
            })
        }

        return filters
    }

    if( isArray(raw) ) {
        let filters = []
        for(let filter in raw) {
            filters = [...filters, ...normalize(raw[filter])]
        }
        return filters
    }

    return normalize(raw)
}

export function processFilters(value, filters, normalize = true, additional = []) {
    let $_filters = filters || []

    if( normalize ) {
        $_filters = normalizeFilters($_filters)
    }

    for( let item of $_filters ) {
        if( typeOf(item.filter) === 'function' ) {
            value = item.filter( value, ...additional )
        } else {
            value = Vue.filter( item.filter )( value, ...item.params )
        }
    }

    return value
}

export function getQueryStringParam(key) {
    if( this.$route.query ) {
        return this.$route.query[key]
    }

    return
}

export function appendQueryString(query = {}, router, route) {
    if( router === undefined ) {
        router = this.$router
    }
    if( route === undefined ) {
        route = this.$route
    }

    if( router ) {
        if( route.query !== undefined ) {
            query = Object.assign({}, route.query, query)
        }

        router.push({
            query
        })
    }
}
